import React, { useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { RiDownload2Line, RiFileExcel2Line, RiSlideshowLine } from 'react-icons/ri';
import { aiChatService } from '../../_services/aiChat.service';
import { humanizeFileName } from './formatters';

const ChatReportDownload = ({ reportPath }) => {
    const [downloading, setDownloading] = useState(false);
    const [error, setError] = useState('');
    const fileName = aiChatService.reportFileName(reportPath);
    const displayFileName = humanizeFileName(fileName);
    const isPowerPoint = /\.pptx$/i.test(fileName);

    const download = async () => {
        setDownloading(true);
        setError('');
        try {
            await aiChatService.downloadReport(reportPath);
        } catch (downloadError) {
            setError(
                downloadError && downloadError.status === 404
                    ? 'Report no longer available'
                    : 'Download failed — try again'
            );
        } finally {
            setDownloading(false);
        }
    };

    return (
        <section className="ai-chat-section ai-chat-report">
            <div className={`ai-chat-report-icon ${isPowerPoint ? 'is-ppt' : 'is-xlsx'}`}>
                {isPowerPoint ? <RiSlideshowLine /> : <RiFileExcel2Line />}
            </div>
            <div className="ai-chat-report-name">
                <strong>Generated report</strong>
                <span title={fileName}>{displayFileName}</span>
                {error && <small role="alert">{error}</small>}
            </div>
            <button type="button" onClick={download} disabled={downloading}>
                {downloading ? <Spinner size="sm" animation="border" /> : <RiDownload2Line />}
                <span>Download</span>
            </button>
        </section>
    );
};

export default ChatReportDownload;
